import React from "react";

import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/src/components/ui/alert-dialog";
import { Button } from "@/src/components/ui/button";

import type { ComponentProps, JSX } from "react";

interface LiveConfirmActionProps {
  label: string;
  title: string;
  description: string;
  confirmLabel: string;
  variant?: ComponentProps<typeof Button>["variant"];
  disabled?: boolean;
  tooltip?: string;
  onConfirm: () => void;
}

function LiveConfirmAction({
  label,
  title,
  description,
  confirmLabel,
  variant = "default",
  disabled = false,
  tooltip,
  onConfirm,
}: LiveConfirmActionProps): JSX.Element {
  const { t } = useTranslation("editor-content");

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button disabled={disabled} title={tooltip} variant={variant}>
          {label}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("liveRegie_cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default LiveConfirmAction;
